import { ref, readonly } from "vue";
import { logger } from "@/infrastructure/services/LoggerService";
export function useAsyncData(fetcher) {
    const data = ref(null);
    const loading = ref(false);
    const loadError = ref(false);
    async function load() {
        loading.value = true;
        loadError.value = false;
        try {
            data.value = await fetcher();
        }
        catch (e) {
            loadError.value = true;
            logger.error("useAsyncData: fetch failed", e);
        }
        finally {
            loading.value = false;
        }
    }
    return {
        data: readonly(data),
        loading: readonly(loading),
        loadError: readonly(loadError),
        load,
        reload: load,
    };
}
